import { mapState, mapGetters, mapActions } from 'vuex'
import Loading from '@/components/Core/Loading'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'

export default {
  name: 'Device',
  components: {
    Loading
  },
  metaInfo () {
    let title = this.categoryName + '管理 | ' + Constants.SiteInfo.title
    this.setMeta({ title: title })
    return this.getMeta
  },
  data () {
    return {
      loading: true,
      registerHash: Constants.RegisterHash,
      
      // テーブルオプション
      tableColumns: [
        'createdAt',
        'modelNumber',
        'modelName',
        'manufacturerName',
        'status',
        'screen_width',
        'modifyButton',
      ],
      tableData: [],
      tableOptions: {
        headings: {
          createdAt: '登録年月日',
          modelNumber: '品番',
          modelName: '機種名',
          manufacturerName: 'メーカー',
          status: 'ステータス',
          screen_width: '解像度',
          modifyButton: '',
        },
        columnsClasses: {
          createdAt: 'wp-10',
          modelNumber: '',
          modelName: '',
          manufacturerName: '',
          status: '',
          screen_width: '',
          modifyButton: 'wp-5',
        },
        sortable: [
          'createdAt',
          'modelNumber',
          'modelName',
          'manufacturerName',
          'status'
        ],
        filterable: [],
        texts: Constants.TableOptions.getTexts(this.categoryName),
        // perPage: Constants.TableOptions.perPage.view,
        perPage: Constants.TablePerPageInitial,
        perPageValues: Constants.TableOptions.perPageValues,
        pagination: Constants.TableOptions.pagination
      },

      // 絞込み
      activeFilters: false,
      filterPerPage: Constants.TablePerPageInitial
    }
  },
  // beforeMount () {
  //   if (this.getPermission('Member')) return
  //   this.$router.push({name: 'Home'})
  // },
  mounted () {
    this.$set(this.tableOptions, 'texts', Constants.TableOptions.getTexts(this.categoryName))

    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.device.categoryName,
      deviceModel: state => state.device.deviceModel,
      syncProccesing: state => state.admp.proccesing,
      // modal
      updatedList: state => state.deviceRegistResolutionModal.updated
    }),
    ...mapGetters({
      getMeta: 'meta/get',
      permittedView: 'permission/permittedView',
      isSmartPhone: 'core/isSmartPhone'
    }),

    loadingDescription () {
      return this.syncProccesing
        ? 'ADMP同期中'
        : ''
    },

    // list
    tablePerPageList () {
      let list = []
      Constants.TablePerPage.forEach(item => list.push({
        value: item,
        label: item
      }))
      return list
    },
    showFilters () {
      return !this.isSmartPhone ||
        this.activeFilters
    },
  },
  watch: {
    syncProccesing: function (to) {
      if (!to) {
        this.init()
      }
    },
    updatedList: function (to) {
      if (!to) return
      // モーダルで対象配信タイプの変更がされたら一覧を更新
      this.init()
    }
  },
  methods: {
    ...mapActions({
      setMeta: 'meta/set',
      showError: 'error/show',
      loadModel: 'device/loadModel',
      syncAdmp: 'admp/sync',
      showDeviceRegistResolutionModal: 'deviceRegistResolutionModal/show',
    }),

    init () {
      this.loading = true

      //TODO
      let deviceParams = { filters: {} }

      // データ読出し
      this.loadModel({
        deviceParams: deviceParams
      })
        // eslint-disable-next-line
        .then(res => {
          this.loading = false
          this.tableData = $.extend(true, [], this.deviceModel)
        })
        .catch(error => {
          this.showError(error || null)
        })
    },
    getViewData (props) {
      let key = props.column
      let value = props.row[key]

      switch (key) {
        case 'createdAt':
          return Utility.dateFormat(value, 'YYYY/MM/DD')
        case 'status':
          return Utility.getConstantsLabel(['Status'], value)
        case 'screen_width':
          if (!value) return '未設定'
          return props.row.screen_width + ' x ' + props.row.screen_height
      }
      return value
    },
    changePage () {
      // console.log(this.$refs.table.page)
    },

    // 絞り込み
    toggleFilters () {
      this.activeFilters = !this.activeFilters
    },
    changePerPage () {
      this.$refs.table.setLimit(this.filterPerPage)
    },

    modifyItem (props) {
      this.showDeviceRegistResolutionModal({
        targetId: props.row.deviceTypeUuid,
        data: props.row
      })
    }
  }
}